 
import { PayloadAction } from '@reduxjs/toolkit'
import {
  getSignature,
  updateSignature,
} from 'Modules/Communication/shared/api/inbox.api'
import { put, takeEvery, call, select } from 'redux-saga/effects'
import { IClient } from 'shared/models/Client'
import { getActiveClient } from 'shared/store/clients/selectors'
import { closeModal } from 'shared/store/modal'

import {
  fetchEmailSignatureRequest,
  fetchEmailSignatureSuccess,
  fetchEmailSignatureError,
  editEmailSignatureRequested,
  editEmailSignatureError,
  editEmailSignatureSuccess,
} from '.'

function* fetchSignature() {
  try {
    const client: IClient = yield select(getActiveClient)
    const { data } = yield call(getSignature, client.id)

    yield put(fetchEmailSignatureSuccess(data))
  } catch (e: any) {
    console.log(e.response.data)
    yield put(fetchEmailSignatureError(e))
  }
}

function* editSignature({ payload }: PayloadAction<string>) {
  try {
    const client: IClient = yield select(getActiveClient)
    yield call(updateSignature, client.id, payload)

    yield put(closeModal())
    yield put(editEmailSignatureSuccess(payload))
  } catch (e: any) {
    console.log(e.response.data)
    yield put(editEmailSignatureError(e))
  }
}

function* emailSignatureSaga() {
  yield takeEvery(fetchEmailSignatureRequest.type, fetchSignature)
  yield takeEvery(editEmailSignatureRequested.type, editSignature)
}

export default emailSignatureSaga
